export const ErrorPageTemplate: string = `
<div [class.sh-page-section]="!noMargin">
    <sh-notification
        [type]="notificationType.Error"
        [title]="title | translate"
        [message]="message | translate"
        [icon]="'delete'"
    ></sh-notification>
</div>
`;
